/**
 * 主题 API
 * 从后端获取和同步主题配置
 */

import type { ThemeApiResponse, ThemeConfig } from '@ifa/ui';
import { useThemeStore } from './store';
import userTheme from './default';

/**
 * 从 API 获取主题配置
 * TODO: 实现实际的 API 调用
 * @param tenantId 租户 ID（可选）
 * @returns 主题配置或 null
 */
export async function fetchThemeFromAPI(tenantId?: string): Promise<ThemeConfig | null> {
  try {
    // TODO: 替换为实际的 API 调用
    // const response = await fetch(`/api/v1/theme${tenantId ? `?tenantId=${tenantId}` : ''}`);
    // const data: ThemeApiResponse = await response.json();
    // return data.config;

    // 临时：返回 null，使用默认主题
    console.log('[Theme API] fetchThemeFromAPI called, using default theme', { tenantId });
    return null;
  } catch (error) {
    console.error('[Theme API] Failed to fetch theme:', error);
    return null;
  }
}

/**
 * 初始化主题配置
 * 优先使用 API 主题，回退到默认主题
 * @param tenantId 租户 ID（可选）
 */
export async function loadThemeConfig(tenantId?: string): Promise<void> {
  const { setTheme } = useThemeStore.getState();

  try {
    // 尝试从 API 获取主题
    const apiTheme = await fetchThemeFromAPI(tenantId);

    if (apiTheme) {
      console.log('[Theme] Loaded theme from API');
      setTheme(apiTheme);
    } else {
      console.log('[Theme] Using default theme');
      // API 没有返回主题，使用默认主题
      // 这里不调用 setTheme，因为默认主题已经在 Store 初始化时设置
    }
  } catch (error) {
    console.error('[Theme] Failed to load theme config:', error);
    // 出错时使用默认主题
  }
}

/**
 * 保存主题配置到 API
 * TODO: 实现实际的 API 调用
 * @param theme 主题配置
 * @returns 是否保存成功
 */
export async function saveThemeToAPI(theme: ThemeConfig): Promise<boolean> {
  try {
    // TODO: 替换为实际的 API 调用
    // const response = await fetch('/api/v1/theme', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify({ config: theme }),
    // });
    // return response.ok;

    console.log('[Theme API] saveThemeToAPI called', theme);
    return true;
  } catch (error) {
    console.error('[Theme API] Failed to save theme:', error);
    return false;
  }
}

/**
 * 切换主题（用户手动切换）
 * @param theme 新的主题配置
 * @param saveToAPI 是否保存到 API
 */
export async function switchTheme(theme: ThemeConfig, saveToAPI: boolean = false): Promise<void> {
  const { setTheme } = useThemeStore.getState();

  // 应用主题
  setTheme(theme);

  // 可选：保存到 API
  if (saveToAPI) {
    await saveThemeToAPI(theme);
  }
}

/**
 * 重置为默认主题
 * @param saveToAPI 是否保存到 API
 */
export async function resetToDefaultTheme(saveToAPI: boolean = false): Promise<void> {
  await switchTheme(userTheme, saveToAPI);
}
